import { render, staticRenderFns } from "./MergeCustomerCard.vue?vue&type=template&id=78a34ae4&scoped=true&lang=pug&"
import script from "./MergeCustomerCard.vue?vue&type=script&lang=ts&"
export * from "./MergeCustomerCard.vue?vue&type=script&lang=ts&"
import style0 from "./MergeCustomerCard.vue?vue&type=style&index=0&id=78a34ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a34ae4",
  null
  
)

export default component.exports